import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-xl border border-dashed border-background-300 bg-background-50">
      <span className="w-16 h-16 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="font-heading font-semibold text-base text-foreground-900">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 mt-2 max-w-md leading-relaxed">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          {actionLabel}
        </Link>
      )}
      {actionLabel && onAction && !actionTo && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}